import SelectEmployeeFromOffice from "@components/SelectEmployeeFromOffice";
import { ChangeEmail } from "./components";
import { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useEmployeeDetails } from "@hooks/HRM/employee/useEmployee";
import { updateEmail } from "@api/updateEmail";
import { ErrorModal, SuccessModal } from "@components";
import { UpdateEmail } from "@type/HRM/settings/updateEmail";
const EmailUpdate = () => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number>();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const employeeInfo = useEmployeeDetails(selectedEmployeeId);
  const { email } = employeeInfo;

  const methods = useForm();
  const getSelectedEmployeeId = (id: number | undefined) => {
    setSelectedEmployeeId(id);
  };

  // MODAL SECTION
  const closeErrorModal = () => setIsErrorModalOpen(false);
  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    methods.reset();
    setSelectedEmployeeId(undefined);
  };

  const onSubmit: SubmitHandler<any> = async (data: UpdateEmail) => {
    const { newEmail, previousEmail } = data;
    try {
      if (selectedEmployeeId) {
        const response = await updateEmail(selectedEmployeeId, {
          newEmail,
          previousEmail,
        });
        if (response) {
          setIsSuccessModalOpen(true);
        } else {
          setIsErrorModalOpen(true);
        }
      }
    } catch (error: any) {
      setIsErrorModalOpen(true);
      setErrorMessage(error.response.data.message);
    }
  };
  return (
    <div>
      {/* MODAL SECTION */}
      <>
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
          subtitle={errorMessage ? errorMessage : "Something went wrong"}
        />
      </>
      {/* MODAL SECTION */}
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <SelectEmployeeFromOffice
            getSelectedEmployeeId={getSelectedEmployeeId}
          />
          <ChangeEmail email={email} />
        </form>
      </FormProvider>
    </div>
  );
};

export default EmailUpdate;
